var TIMESTAMP = null;

// Component to open modal on markers/hotspots.
AFRAME.registerComponent('open-modal', {
    schema: {
        on: {default: 'click'},
        yPos: {type: 'number', default: 0.4},
        zPos: {type: 'number', default: -2.5},
        mID: {type: 'string', default: ''}
    },
    init: function() {
        var data = this.data;
        var el = this.el;
        var markerEl = el.getAttribute("marker");

        el.addEventListener(data.on, function (evt) {

            var modalWrapper = document.getElementById('modal-wrapper');
            var modalEl = document.getElementById('modal');
            var modalContent = document.getElementById('modalcomp');
            var modalImg = document.getElementById('modalimg');
            var modalObj = document.getElementById('modalobj');

            if(TIMESTAMP == null || TIMESTAMP + 1000 < evt.timeStamp) {
                modalWrapper.setAttribute('visible','true');
                modalWrapper.setAttribute('scale','1 1 1');
                modalWrapper.setAttribute('rotation', `${markerEl.xRot} ${markerEl.yRot} 0`);
                modalWrapper.setAttribute('position', `0 ${markerEl.yPos} 0`);

                modalEl.setAttribute('position', `0 ${data.yPos} ${data.zPos}`);

                TIMESTAMP = evt.timeStamp;
            }


            switch (data.mID) {
              case 'ocean':
                modalContent.setAttribute('material','src:#poi_panel_ocean');
                modalImg.setAttribute('material','src:;');
                modalImg.setAttribute('scale','0.00001 0.00001 0.00001');
                modalImg.setAttribute('visible','false');                
                modalObj.setAttribute('scale','0.00001 0.00001 0.00001');
                modalObj.setAttribute('visible','false');
                break;
              case 'wind':
                modalContent.setAttribute('material','src:#poi_panel_wind');
                modalImg.setAttribute('material','src:;');
                modalImg.setAttribute('scale','0.00001 0.00001 0.00001');
                modalImg.setAttribute('visible','false');
                modalObj.setAttribute('scale','0.00001 0.00001 0.00001');
                modalObj.setAttribute('visible','false');
                break;
              case 'logging':
                modalContent.setAttribute('material','src:#poi_panel_logging');
                modalImg.setAttribute('material','src:;');
                modalImg.setAttribute('scale','0.00001 0.00001 0.00001');
                modalImg.setAttribute('visible','false');
                modalObj.setAttribute('scale','0.00001 0.00001 0.00001');
                modalObj.setAttribute('visible','false');
                break;
              case 'salal':
                modalContent.setAttribute('material','src:#poi_panel_salal');
                modalImg.setAttribute('material','src:#poi_img_salal;');
                modalImg.setAttribute('scale','1 1 1');
                modalImg.setAttribute('visible','true');
                modalObj.setAttribute('scale','0.25 0.25 0.25');
                modalObj.setAttribute('visible','true');
                break;
              case 'sitka':
                modalContent.setAttribute('material','src:#poi_panel_sitka');
                modalImg.setAttribute('material','src:#poi_img_sitka;');
                modalImg.setAttribute('scale','1 1 1');
                modalImg.setAttribute('visible','true');
                modalObj.setAttribute('scale','0.25 0.25 0.25');
                modalObj.setAttribute('visible','true');
                break;
              case 'wsfern':
                modalContent.setAttribute('material','src:#poi_panel_wsfern');
                modalImg.setAttribute('material','src:#poi_img_wsfern;');
                modalImg.setAttribute('scale','1 1 1');
                modalImg.setAttribute('visible','true');
                modalObj.setAttribute('scale','0.25 0.25 0.25');
                modalObj.setAttribute('visible','true');
                break;
              case 'dfern':
                modalContent.setAttribute('material','src:#poi_panel_dfern');
                modalImg.setAttribute('material','src:#poi_img_dfern;');
                modalImg.setAttribute('scale','1 1 1');
                modalImg.setAttribute('visible','true');
                modalObj.setAttribute('scale','0.25 0.25 0.25');
                modalObj.setAttribute('visible','true');
                break;
              case 'vine':
                modalContent.setAttribute('material','src:#poi_panel_vine');
                modalImg.setAttribute('material','src:#poi_img_vine;');
                modalImg.setAttribute('scale','1 1 1');
                modalImg.setAttribute('visible','true');
                modalObj.setAttribute('scale','0.25 0.25 0.25');
                modalObj.setAttribute('visible','true');
                break;
              case 'sberry':
                modalContent.setAttribute('material','src:#poi_panel_sberry');
                modalImg.setAttribute('material','src:#poi_img_sberry;');
                modalImg.setAttribute('scale','1 1 1');
                modalImg.setAttribute('visible','true');
                modalObj.setAttribute('scale','0.25 0.25 0.25');
                modalObj.setAttribute('visible','true');
                break;
              case 'lily':
                modalContent.setAttribute('material','src:#poi_panel_lily');
                modalImg.setAttribute('material','src:#poi_img_lily;');
                modalImg.setAttribute('scale','1 1 1');
                modalImg.setAttribute('visible','true');
                modalObj.setAttribute('scale','0.25 0.25 0.25');
                modalObj.setAttribute('visible','true');
                break;
              case 'wfern':
                modalContent.setAttribute('material','src:#poi_panel_wfern');
                modalImg.setAttribute('material','src:#poi_img_wfern;');
                modalImg.setAttribute('scale','1 1 1');
                modalImg.setAttribute('visible','true');
                modalObj.setAttribute('scale','0.25 0.25 0.25');
                modalObj.setAttribute('visible','true');
                break;
              case 'mfmoss':
                modalContent.setAttribute('material','src:#poi_panel_mfmoss');
                modalImg.setAttribute('material','src:#poi_img_mfmoss;');
                modalImg.setAttribute('scale','1 1 1');
                modalImg.setAttribute('visible','true');
                modalObj.setAttribute('scale','0.25 0.25 0.25');
                modalObj.setAttribute('visible','true');
                break;
              case 'lmoss':
                modalContent.setAttribute('material','src:#poi_panel_lmoss');
                modalImg.setAttribute('material','src:#poi_img_lmoss;');
                modalImg.setAttribute('scale','1 1 1');
                modalImg.setAttribute('visible','true');
                modalObj.setAttribute('scale','0.25 0.25 0.25');
                modalObj.setAttribute('visible','true');
            }


        });
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/open-modal.js
// module id = 10
// module chunks = 0